import { SidebarPrimary } from "./sidebar-primary";
import { SidebarSecondary, PortalType } from "./sidebar-secondary";
import { MenuConfig } from "@/config/types";

interface SidebarProps {
  menuConfig?: MenuConfig;
  portalType?: PortalType;
  enabledModules?: string[];
  onLogout?: () => void;
  isLogoutPending?: boolean;
}

export function Sidebar({ 
  menuConfig, 
  portalType = 'platform', 
  enabledModules = ['core'],
  onLogout, 
  isLogoutPending 
}: SidebarProps) {
  return (
    <aside className="fixed overflow-hidden top-(--header-height) start-0 z-20 bottom-0 transition-all duration-300 flex items-stretch flex-shrink-0 w-(--sidebar-width) in-data-[sidebar-open=false]:w-(--sidebar-collapsed-width) border-e border-border">
      <SidebarPrimary 
        onLogout={onLogout} 
        isLogoutPending={isLogoutPending}
        portalType={portalType}
        enabledModules={enabledModules}
      />
      <SidebarSecondary 
        menuConfig={menuConfig} 
        portalType={portalType}
      />
    </aside>
  );
}